import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetMachineExceptionImageResData extends ApiGenericResponse {
    image: string = null;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.MachineExceptionImage) {
            this.image = obj.MachineExceptionImage;
        }
    }
}
